import {
	Component,
	HostListener,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Groups, StatusUSerGroups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { deleteStatusGroup } from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { ModalStatusGroupsComponent } from 'projects/access-control/src/app/UI/components/modal-status-groups/modal-status-groups.component';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';

interface DataTranslateStatus {
	buttonNew: string;
	buttonEdit: string;
	delete: string;
	buttonDelete: string;
}
@Component({
	selector: 'app-status',
	templateUrl: './status.component.html',
	styleUrls: ['./status.component.scss'],
})
export class StatusComponent implements OnInit, OnChanges, OnDestroy {
	@Input() group: Groups = {} as Groups;
	@Input() loading: boolean = false;
	elementsDelete: string = '';
	subscriptionTranslate!: Subscription;
	translateStatus: DataTranslateStatus = {} as DataTranslateStatus;
	numberOfColums = 3;
	status: StatusUSerGroups[] = [];
	openAlert = false;
	valueModalDelete = '';
	statusSelected: StatusUSerGroups = {} as StatusUSerGroups;
	constructor(
		public dialog: MatDialog,
		private translateService: TranslateService,
		private store: Store
	) {}

	ngOnInit(): void {
		this.getTranslate();
	}
	openDialogNewStatus(type = 'newRole', status: StatusUSerGroups = {} as StatusUSerGroups) {
		const dialogRef = this.dialog.open(ModalStatusGroupsComponent, {
			height: '610px',
			width: '697px',
			data: { status, group: this.group, type },
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.updateStatus();
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		if (window.innerWidth > 1024) {
			this.numberOfColums = 3;
		}

		if (window.innerWidth < 1024) {
			this.numberOfColums = 2;
		}
	}
	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateStatus = data.pages.groups.tabs.infoTabs.status;
			this.updateStatus();
		});
	}

	closeModalAlert(resp: any) {
		if (resp.value === 'deleteStatus' && resp.resp) {
			const status: StatusUSerGroups[] = this.status.filter(
				(itemStatus) => itemStatus.name !== this.statusSelected.name
			);
			const group: Groups = {
				...this.group,
				statusDeleted: {
					name: this.statusSelected.name,
					color: this.statusSelected.color,
				},
				statusUser: status,
			} as Groups;
			this.store.dispatch(
				deleteStatusGroup({ group, ids: { pk: this.group.pk, sk: this.group.sk } })
			);
		}
		this.openAlert = false;
	}

	updateStatus() {
		this.status = this.group.statusUser.map((status) => {
			let items: MenuItem[] = [
				{
					label: this.translateStatus.buttonEdit,
					icon: 'pi pi-pencil',
					command: () => {
						this.openDialogNewStatus('updateStatus', status);
					},
				},
			];
			items =
				status.name.toLowerCase() === 'open'
					? [...items]
					: [
							...items,
							{
								label: this.translateStatus.buttonDelete,
								icon: 'pi pi-trash',
								command: () => {
									this.statusSelected = status;
									this.elementsDelete = `${this.translateStatus.delete} '${status.name}'`;
									this.openAlert = true;
									this.valueModalDelete = 'deleteStatus';
								},
							},
					  ];
			return {
				...status,
				items,
			};
		});
	}
	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
